// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
export var elevation = {
  levelOne: 1000,
  levelTwo: 1100,
  levelThree: 1200
};
export var level = {
  light: {
    glasswall: {
      blur: '16px',
      color: 'rgba(51,51,51,0.5)'
    },
    level4: '0 1px 4px 1px rgba(33,33,33,0.2)',
    level8: '0 2px 8px 2px rgba(33,33,33,0.2)',
    level12: '0 3px 12px 3px rgba(33,33,33,0.2)',
    level16: '0 4px 16px 4px rgba(33,33,33,0.2)',
    level20: '0 5px 20px 5px rgba(33,33,33,0.2)'
  },
  dark: {
    glasswall: {
      blur: '16px',
      color: 'rgba(51,51,51,0.7)'
    },
    level4: '0 1px 4px 1px rgba(0,0,0,0.4)',
    level8: '0 2px 8px 2px rgba(0,0,0,0.4)',
    level12: '0 3px 12px 3px rgba(0,0,0,0.4)',
    level16: '0 4px 16px 4px rgba(0,0,0,0.4)',
    level20: '0 5px 20px 5px rgba(0,0,0,0.4)'
  },
  highContrast: {
    glasswall: {
      blur: '16px',
      color: '#16141D'
    },
    level4: 'none',
    level8: 'none',
    level12: 'none',
    level16: 'none',
    level20: 'none'
  }
};
export var palette = {
  light: {
    background: {
      "default": '#fafafa',
      container: '#fff',
      disabled: '#e8e8e8'
    },
    foreground: {
      "default": '#212121',
      medium: '#404040',
      light: '#737373',
      inverse: '#fff',
      disabled: '#a3a3a3'
    },
    stroke: {
      "default": '#d9d9d9'
    },
    primary: {
      "default": '#0076ad',
      hover: '#015985',
      active: '#024466',
      background: 'rgba(0,118,173,0.1)',
      backgroundLight: 'rgba(0,118,173,0.05)',
      foreground: '#fff'
    },
    neutral: {
      "default": '#666666',
      hover: '#545454',
      active: '#404040',
      background: 'rgba(102,102,102,0.1)',
      backgroundLight: 'rgba(102,102,102,0.05)',
      foreground: '#fff'
    },
    positive: {
      "default": '#00834b',
      hover: '#006c3e',
      active: '#005a35',
      background: 'rgba(0,131,75,0.1)',
      backgroundLight: 'rgba(0,131,75,0.05)',
      foreground: '#fff'
    },
    warning: {
      "default": '#ff8900',
      hover: '#d46b00',
      active: '#b2600c',
      background: 'rgba(255,137,0,0.1)',
      backgroundLight: 'rgba(255,137,0,0.05)',
      foreground: '#fff'
    },
    negative: {
      "default": '#cc2c00',
      hover: '#9f2301',
      active: '#802208',
      background: 'rgba(204,44,0,0.1)',
      backgroundLight: 'rgba(204,44,0,0.05)',
      foreground: '#fff'
    }
  },
  dark: {
    background: {
      "default": '#212121',
      container: '#2b2b2b',
      disabled: '#404040'
    },
    foreground: {
      "default": '#fff',
      medium: '#d9d9d9',
      light: '#a3a3a3',
      inverse: '#212121',
      disabled: '#666666'
    },
    stroke: {
      "default": '#545454'
    },
    primary: {
      "default": '#3bb7f6',
      hover: '#73cffe',
      active: '#9fe0fe',
      background: 'rgba(59,183,246,0.1)',
      backgroundLight: 'rgba(59,183,246,0.05)',
      foreground: '#212121'
    },
    neutral: {
      "default": '#a3a3a3',
      hover: '#c2c2c2',
      active: '#d9d9d9',
      background: 'rgba(163,163,163,0.1)',
      backgroundLight: 'rgba(163,163,163,0.05)',
      foreground: '#212121'
    },
    positive: {
      "default": '#00d072',
      hover: '#4ef5ab',
      active: '#78ffc2',
      background: 'rgba(0,208,114,0.1)',
      backgroundLight: 'rgba(0,208,114,0.05)',
      foreground: '#212121'
    },
    warning: {
      "default": '#ff8900',
      hover: '#ffa238',
      active: '#ffb866',
      background: 'rgba(255,137,0,0.1)',
      backgroundLight: 'rgba(255,137,0,0.05)',
      foreground: '#212121'
    },
    negative: {
      "default": '#ff6445',
      hover: '#ff8373',
      active: '#ffa59e',
      background: 'rgba(255,100,69,0.1)',
      backgroundLight: 'rgba(255,100,69,0.05)',
      foreground: '#212121'
    }
  },
  highContrast: {
    background: {
      "default": '#16141D',
      container: '#16141D',
      disabled: '#545454'
    },
    foreground: {
      "default": '#fff',
      medium: '#fff',
      light: '#fff',
      inverse: '#16141D',
      disabled: '#ADADAD'
    },
    stroke: {
      "default": '#ADADAD'
    },
    primary: {
      "default": '#FFF700',
      hover: '#FE6AFF',
      active: '#00D3FF',
      background: '#16141D',
      backgroundLight: '#16141D',
      foreground: '#16141D'
    },
    neutral: {
      "default": '#FFF700',
      hover: '#FE6AFF',
      active: '#00D3FF',
      background: '#16141D',
      backgroundLight: '#16141D',
      foreground: '#16141D'
    },
    positive: {
      "default": '#00d072',
      hover: '#FE6AFF',
      active: '#00D3FF',
      background: '#16141D',
      backgroundLight: '#16141D',
      foreground: '#16141D'
    },
    warning: {
      "default": '#ff8900',
      hover: '#FE6AFF',
      active: '#00D3FF',
      background: '#16141D',
      backgroundLight: '#16141D',
      foreground: '#16141D'
    },
    negative: {
      "default": '#ff6445',
      hover: '#FE6AFF',
      active: '#00D3FF',
      background: '#16141D',
      backgroundLight: '#16141D',
      foreground: '#16141D'
    }
  }
};
export var shape = {
  round: {
    borderRadius: '0px'
  },
  sharp: {
    borderRadius: 0
  }
};
export var spacing = {
  standard: {
    borderRadius: {
      one: '12px',
      two: '8px',
      three: '16px'
    },
    padding: {
      one: '4px',
      two: '8px',
      three: '12px',
      four: '16px',
      five: '20px',
      six: '24px',
      seven: '28px',
      eight: '32px',
      intermediate: '12px'
    }
  },
  high: {
    borderRadius: {
      one: '8px',
      two: '8px',
      three: '12px'
    },
    padding: {
      one: 0,
      two: '4px',
      three: '8px',
      four: '12px',
      five: '16px',
      six: '20px',
      seven: '24px',
      eight: '28px',
      intermediate: '6px'
    }
  }
};
var system = {
  elevation: elevation,
  level: level,
  palette: palette,
  shape: shape,
  spacing: spacing
};
export default system;